if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.buttons = Array.from(this.querySelectorAll('.tab-button'));
      this.contents = Array.from(this.querySelectorAll('.tab-content'));
      if (!this.buttons.length || !this.contents.length) return;
      this.initialized = true;
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.switchTab(index));
        button.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.buttons.length) % this.buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.buttons.length - 1;
          else return;
          event.preventDefault();
          this.switchTab(next);
          this.buttons[next].focus();
        });
      });
    }

    async switchTab(index) {
      const content = this.contents[index];
      if (!content || !this.buttons[index]) return;
      this.requestedIndex = index;
      if (content.querySelector('[data-tab-fallback]')) {
        this.buttons[index].setAttribute('aria-busy', 'true');
        try {
          if (!this.panelRequest) {
            const url = new URL(window.location.href);
            url.searchParams.set('section_id', this.dataset.sectionId);
            this.panelRequest = fetch(url, { signal: AbortSignal.timeout(15000) })
              .then((response) => {
                if (!response.ok) throw new Error(`Category request failed: ${response.status}`);
                return response.text();
              })
              .then((html) => new DOMParser().parseFromString(html, 'text/html'))
              .catch((error) => {
                this.panelRequest = null;
                throw error;
              });
          }
          const source = (await this.panelRequest).getElementById(content.id);
          if (!source || source.querySelector('[data-tab-fallback]')) throw new Error('Category content is unavailable');
          content.replaceChildren(...Array.from(source.childNodes, (node) => document.importNode(node, true)));
        } catch (error) {
          const fallback = content.querySelector('[data-tab-fallback]');
          if (fallback) fallback.setAttribute('role', 'alert');
        } finally {
          this.buttons[index].removeAttribute('aria-busy');
        }
        if (this.requestedIndex !== index) return;
      }
      this.buttons.forEach((button, current) => {
        button.classList.toggle('active', current === index);
        button.setAttribute('aria-selected', String(current === index));
        button.tabIndex = current === index ? 0 : -1;
      });
      this.contents.forEach((panel, current) => panel.classList.toggle('active', current === index));
      requestAnimationFrame(() => {
        content.querySelectorAll('slider-component').forEach((slider) => slider.resetPages?.());
        content.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.remove('scroll-trigger--offscreen'));
      });
    }
  }
  customElements.define('tabs-component', TabsComponent);
}
